import type { PostHog, PostHogConfig } from '@posthog/types';
import { getCurrentUser } from '../CurrentUser';
import { isTrackingEnabled } from '../Tracking';
import loadScript from '../loadScript';

const POSTHOG_OPTIONS: Partial<PostHogConfig> = {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2026-05-30',
    capture_pageview: 'history_change',
    // autocapture: {
    //     element_allowlist: ['a', 'button', 'select'],
    //     url_ignorelist: ['.*app/observer/.*'],
    //     capture_copied_text: false,
    // },
    autocapture: false,
    disable_session_recording: true,
    disable_surveys: true,
    loaded: onPostHogLoad,
    secure_cookie: true,
    advanced_disable_feature_flags: true,
    advanced_disable_toolbar_metrics: true,
    mask_all_text: true,
    mask_all_element_attributes: true,
    mask_personal_data_properties: true,
};

const POSTHOG_API_KEY = 'phc_C3gBhq7AGBfWTGAHFB2wiMTG8ZpXDdp97w6AAW6SAZGH';

const POSTHOG_ENABLED = false;

async function onPostHogLoad(posthog: PostHog) {
    const user = getCurrentUser();
    posthog.identify(user.id);
    posthog.group('company', user.company.id);
}

export function initPostHog() {
    try {
        const user = getCurrentUser();
        if (!POSTHOG_ENABLED || !isTrackingEnabled() || !user.isHR) {
            return;
        }

        if (window.posthog) {
            return;
        }

        loadScript(
            POSTHOG_OPTIONS.api_host!.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js'
        ).then(() => {
            window.posthog.init(POSTHOG_API_KEY, POSTHOG_OPTIONS);
        });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Error initializing PostHog:', err);
    }
}
